import PropTypes from 'prop-types';
import {
    Card,
    CardContent,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from '@mui/material';
import { formatKpiValue, pickLayout } from '../kpiUtils';

const humanize = (key) =>
    String(key)
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (letter) => letter.toUpperCase());

const KpiTableCard = ({ item }) => {
    const layout = pickLayout(item.layout, { md: 12, height: 'auto' });
    const rows = item.rows || [];
    const columns = rows[0] ? Object.keys(rows[0]) : [];
    const numeric = columns.filter((column, index) => index > 0);

    return (
        <Grid item xs={layout.xs} sm={layout.sm} md={layout.md} lg={layout.lg}>
            <Card elevation={0} sx={{ borderRadius: 3, border: '1px solid #EDE4F5' }}>
                <CardContent>
                    <Typography variant="h5" sx={{ fontWeight: 700, color: '#2A1638', mb: 2 }}>
                        {item.titulo}
                    </Typography>
                    <TableContainer>
                        <Table size="small">
                            <TableHead>
                                <TableRow sx={{ bgcolor: '#F8F4FB' }}>
                                    {columns.map((column) => (
                                        <TableCell key={column} sx={{ fontWeight: 700, color: '#6E368C' }}>
                                            {humanize(column)}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows.map((row, index) => (
                                    <TableRow key={index} hover>
                                        {columns.map((column) => (
                                            <TableCell key={column}>
                                                {numeric.includes(column) && !Number.isNaN(Number(row[column]))
                                                    ? formatKpiValue(row[column], 'number')
                                                    : row[column] ?? '—'}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                ))}
                                {rows.length === 0 && (
                                    <TableRow>
                                        <TableCell colSpan={columns.length || 1} align="center">
                                            Sem dados para o filtro selecionado.
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </CardContent>
            </Card>
        </Grid>
    );
};

KpiTableCard.propTypes = {
    item: PropTypes.object
};

export default KpiTableCard;
